export default (state = { items: [], mode: '' }, action = {}) => {
  switch (action.type) {
    case 'SET_MENU_ITEMS':
      return { items: action.items, mode: state.mode };
    case 'SET_MODE':
      return { items: state.items, mode: action.mode };
    default:
      return state;
  }
};
